<template>
  <div class="mx-auto">
    <b-row >
      <b-col xxs="12">
  

        <div class="row no-gutters bg-white my-5">
        
          <div class="col-12">
            <b-list-group flush>
              <b-list-group-item style="background: transparent">
               <br> <i class="lni lni-envelope font-size-26 text-primary"></i> <br><br>
                <a href="mailto:zaid@rapidsoft.co.za" class="text-body"
                  >zaid@rapidsoft.co.za</a
                ></b-list-group-item
              >
              <b-list-group-item style="background: transparent"
                ><br><i class="lni lni-phone-set font-size-26 text-primary"></i> <br><br><a href="tel:+27118392645"
                 class="text-body" >(27) 11 839 2645</a
                ></b-list-group-item
              >
              <b-list-group-item style="background: transparent">
               <br> <i class="lni lni-map-marker font-size-26 text-primary"></i><br><br>
                11 Magalies Street Hurst Hill<br />
                2092<br />
                Johannesburg<br />
                South Africa</b-list-group-item
              >

            </b-list-group>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_APP_NAME,
    };
  },
};
</script>
